$("a.ratesdetails").click(function () {
    $("#RatesDetailsInfo").html($(this).attr("details"));
});